var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FancySelect',_vm._g({staticClass:"selector",attrs:{"options":_vm.users,"loading":_vm.loading,"value":_vm.value,"multiple":_vm.multiple,"reset-after":_vm.resetAfter,"clearable":_vm.clearable,"placeholder":_vm.placeholder}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }